import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CONTACT } from "../data/site";
import { Reveal, MaskedLine } from "../components/Reveal";
import { Seo } from "../components/Seo";

const sections = [
  {
    title: "Éditeur du site",
    content: [
      `${CONTACT.fullName} — Société par actions simplifiée (SAS) au capital de ${CONTACT.capital}.`,
      `Siège social : ${CONTACT.address}.`,
      `SIREN : ${CONTACT.siren} — RCS de Grenoble.`,
      `Directeur de la publication : ${CONTACT.director}, Président.`,
      `Contact : ${CONTACT.email} — ${CONTACT.phone}.`,
    ],
  },
  {
    title: "Hébergement",
    content: [
      "Ce site est hébergé au sein d'une infrastructure cloud professionnelle. Pour toute question relative à l'hébergement, contactez l'éditeur aux coordonnées ci-dessus.",
    ],
  },
  {
    title: "Propriété intellectuelle",
    content: [
      "L'ensemble des contenus du site (textes, photographies, identité visuelle) est la propriété exclusive de la SAS Vaucopin, sauf mention contraire. Toute reproduction, même partielle, est interdite sans autorisation écrite préalable.",
    ],
  },
  {
    title: "Données personnelles (RGPD)",
    content: [
      "Les informations transmises via le formulaire de demande de renseignement (nom, email, téléphone, dates de séjour, message) sont utilisées exclusivement pour répondre à votre demande et gérer votre éventuelle réservation. Elles ne sont ni cédées, ni vendues à des tiers.",
      "Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, d'opposition et de suppression de vos données.",
      `Pour exercer ces droits, contactez notre référent protection des données : ${CONTACT.privacy}.`,
    ],
    link: {
      to: "/politique-de-confidentialite",
      label: "Consultez notre Politique de confidentialité pour le détail des traitements",
    },
  },
  {
    title: "Cookies",
    content: [
      "Ce site n'utilise pas de cookies de suivi publicitaire. Seuls des cookies techniques strictement nécessaires au fonctionnement du site peuvent être déposés.",
    ],
  },
];

export default function MentionsLegales() {
  return (
    <div data-testid="legal-page" className="pt-40 pb-24 md:pb-32">
      <Seo titleKey="seo.legal.title" descKey="seo.legal.description" />
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <p className="text-xs uppercase tracking-[0.25em] text-pine-light font-semibold mb-6">Informations légales</p>
        <h1 className="font-serif text-4xl sm:text-6xl tracking-tighter text-pine leading-[0.95]">
          <MaskedLine delay={0.1}>Mentions légales</MaskedLine>
        </h1>

        <div className="mt-16 space-y-16">
          {sections.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.05}>
              <section data-testid={`legal-section-${i}`} className="border-t border-pine/15 pt-8">
                <h2 className="font-serif text-2xl md:text-3xl text-pine tracking-tight">
                  <span className="text-wood-dark mr-4">0{i + 1}.</span>
                  {s.title}
                </h2>
                <div className="mt-6 space-y-4">
                  {s.content.map((p) => (
                    <p key={p.slice(0, 30)} className="text-ink/70 leading-relaxed">{p}</p>
                  ))}
                  {s.link && (
                    <Link
                      to={s.link.to}
                      data-testid="legal-privacy-crosslink"
                      className="group inline-flex items-center gap-2 text-pine font-semibold border-b border-wood-dark/50 pb-0.5 hover:border-pine transition-colors"
                    >
                      {s.link.label}
                      <ArrowUpRight aria-hidden className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </Link>
                  )}
                </div>
              </section>
            </Reveal>
          ))}
        </div>

        <p className="mt-20 text-sm text-ink/40">Dernière mise à jour : juillet 2026.</p>
      </div>
    </div>
  );
}
